import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BaseComponent } from "../../base.component";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NewsService, News } from "app/services/news.service";
import { Image } from 'app/services/image.service';
import { NotificationsService } from "angular2-notifications";

@Component({
	selector: 'app-news-add-edit',
	templateUrl: './news-add-edit.component.html',
	styleUrls: ['./news-add-edit.component.less']
})
export class NewsAddEditComponent extends BaseComponent implements OnInit {

	param_id: string;
	item: News;

	formTitle: string = 'Add News';
	buttonText: string = 'Save News';

	editor;
	error:any;

	newsForm: NgForm;
	@ViewChild('newsForm') currentForm: NgForm;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public newsService: NewsService,
		private notificationsService: NotificationsService,
	) {
		super();
	}

	ngOnInit() {
		this.setupTinymce();
		
		this.item = new News()
		this.param_id = this.route.snapshot.params['id'];
		if (this.param_id) {
			this.formTitle = 'Edit News';
			this.buttonText = 'Update News';
			this.newsService.getNews(this.param_id).subscribe(news => {
				this.item = news;
				this.editor.setContent(this.item.content);
			});
		}
	}

	setupTinymce() {
		tinymce.init({
			selector           : '.tinymce-textarea',
			height             : 300,
			menubar            : false,
			automatic_uploads  : false,
			relative_urls      : false,
			remove_script_host : false,
			branding           : false,
			toolbar1           : 'bold italic underline strikethrough alignleft aligncenter alignright alignjustify styleselect fontselect fontsizeselect code',
			toolbar2           : 'bullist numlist outdent indent blockquote removeformat subscript superscript hr link unlink image forecolor backcolor table charmap',
			toolbar3           : "",
			plugins            : [
				'anchor autolink charmap code contextmenu directionality emoticons fullscreen hr image link lists nonbreaking paste preview spellchecker table textcolor wordcount'
			],
			skin_url           : '/assets/skins/lightgray',
			content_css        : '/assets/css/tinymce-content.css',
			font_formats       : [
					'Arial=Arial, Helvetica, sans-serif',
					'Times New Roman="Times New Roman", Times, serif',
					'Courier New="Courier New", Courier, monospace',
					'Verdana=Verdana, Geneva, sans-serif'
				].join(';'),
			fontsize_formats  : '36px 30px 24px 18px 14px 12px',
			// font_formats       : "Bebas Neue=bebas_neue;"+"Bebas Neue Book=bebas_neue_book;"+"Brandon Grotesque=brandon_grotesque;"+"Gotham=gotham;"+"Gotham Book=gotham_book;"+"Roboto=robotomedium;",
			// fontsize_formats   : "0.25em 0.50em 0.75em 1.0em 1.25em 1.50em 1.75em 2.0em 2.25em 2.50em 2.75em 3.0em 3.25em 3.50em 3.75em 4.0em 4.25em 4.50em 4.75em 5.0em 5.25em 5.50em 5.75em 6.0em",
			setup: editor => {
				this.editor = editor;
			},
		});
	}

	imageSelected(image: Image) {
        this.item.image = image.url[0]
        this.error = '';
    }

	formAction() {
		var self = this;
		var imageCheck = this.item.image;
		this.item.content = this.editor.getContent();

		if (this.formValidation(false) && imageCheck) {
			 this.error = '';

			if (this.param_id) {
				this.newsService.updateNews(this.param_id, this.item).then(function(){
					self.router.navigate(['/news']);
					self.notificationsService.success('Updated','1 news updated');
				}).catch(function(e){
					console.log('There is an error. '+e.message);
				}) ;
			}
			else {
				this.newsService.addNews(this.item).then(function(){
					// alert('News has been successfully added');
					self.router.navigate(['/news']);
					self.notificationsService.success('Added','1 news added');
				}).catch(function(e){
					console.log('There is an error. '+e.message);
				}) ;
			}
		}else if (imageCheck) {
			this.error = '';
		} else {
            this.error = 'No Image selected';
        }
	}

	onRemove() {
		this.item.image = '';
	}

	ngAfterViewChecked() {
		this.formChanged();
	}

	formChanged() {
		if (this.currentForm === this.newsForm) { return; }

		this.newsForm = this.currentForm;
		if (this.newsForm) {
			this.newsForm.valueChanges
				.subscribe(data => {
					this.formValidation(true)
				});
		}
	}

	formValidation(checkDirty = true) {
		const form = this.newsForm.form;
		for (const field in form.controls) {
			const control = form.get(field)
			if (control) {
				if (checkDirty && !control.dirty) {
					continue;
				}
				this.formErrors[field] = '';
				if (!control.valid) {
					const messages = this.validationMessages[field] || {};
					for (const key in control.errors) {
						this.formErrors[field] += messages[key] + ' ';
					}
				}
			}
		}
		return form.valid;
	}

	formErrors = {
		'title' : ''
	};

	validationMessages = {
		'title': {
			'required': 'This field is required.',
		}
	};
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/news/news-add-edit/news-add-edit.component.ts